import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;

import { observable, runInAction, computed, makeObservable } from "mobx";
import * as valid from "card-validator";
import { insertDelimiters, isAddressValid, isCityValid, isZipValid, isAlphaOrContainsSpace, DEFAULT_MAX_CC_NUMBER_LENGTH, COUNTRIES, extractFromFullName, getCardTypeInfo } from "@dp/common";
import { InputAction } from "@dp/common";
var CreditCardModel = (_class = /*#__PURE__*/function () {
  _createClass(CreditCardModel, [{
    key: "checkForFirstAndLastNameError",
    value: function checkForFirstAndLastNameError(errObj) {
      if (!(!!this._firstName.trim() && !!this._lastName.trim())) {
        errObj["firstAndLastName"] = "Please provide full name.";
      }
    }
  }, {
    key: "checkForCreditCardDetailsError",
    value: function checkForCreditCardDetailsError(errObj) {
      if (!this.isEditingCreditCard) {
        if (!!!this.cNumber) {
          errObj["cardNumber"] = "Please provide card number.";
        } else if (!this.isCardNumberValid) {
          errObj["cardNumber"] = "Invalid Card Number.";
        }
      }

      if (!!!this.expiry) {
        errObj["expiry"] = "Please provide a valid expiry date.";
      } else if (!this.isCardExpiryValid) {
        errObj["expiry"] = "Invalid Expiry.";
      }

      if (!!!this.cvv) {
        errObj["cvv"] = "Please provide a valid cvv number.";
      } else if (!this.isCardCVVValid) {
        errObj["cvv"] = "Invalid CVV.";
      }
    }
  }, {
    key: "checkForCreditCardAddressError",
    value: function checkForCreditCardAddressError(errObj) {
      if (!!!this.zipCode) {
        errObj["zipCode"] = "Please provide a valid zip.";
      } else if (!this.isZipCodeValid) {
        errObj["zipCode"] = "Invalid zip.";
      }

      if (this.fullAVSEnabled) {
        if (!!!this.addressLine1) {
          errObj["addressLineOne"] = "Please enter the address.";
        } else if (!this.isAddressLine1Valid) {
          errObj["addressLineOne"] = "Invalid Address.";
        }

        if (!!!this.city) {
          errObj["city"] = "Please enter the city.";
        } else if (!this.isCityValid) {
          errObj["city"] = "Invalid city.";
        }

        if (!!!this.state) {
          errObj["state"] = "Please select the state.";
        }

        if (!!!this.country) {
          errObj["country"] = "Please select the country.";
        }
      }
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};
      this.checkForFirstAndLastNameError(errObj);
      this.checkForCreditCardDetailsError(errObj);
      this.checkForCreditCardAddressError(errObj);
      return errObj;
    }
  }]);

  function CreditCardModel(fullAVSEnabled, saveCardMandate) {
    var _this = this;

    _classCallCheck(this, CreditCardModel);

    _initializerDefineProperty(this, "_expiry", _descriptor, this);

    _initializerDefineProperty(this, "_firstName", _descriptor2, this);

    _initializerDefineProperty(this, "_lastName", _descriptor3, this);

    _initializerDefineProperty(this, "_cNumber", _descriptor4, this);

    _initializerDefineProperty(this, "_zipCode", _descriptor5, this);

    _initializerDefineProperty(this, "_isDefault", _descriptor6, this);

    _initializerDefineProperty(this, "_addressLine1", _descriptor7, this);

    _initializerDefineProperty(this, "_addressLine2", _descriptor8, this);

    _initializerDefineProperty(this, "_country", _descriptor9, this);

    _initializerDefineProperty(this, "_agreeDisclaimer", _descriptor10, this);

    _initializerDefineProperty(this, "_saveCreditCard", _descriptor11, this);

    _initializerDefineProperty(this, "_cvv", _descriptor12, this);

    _initializerDefineProperty(this, "_saveCardMandate", _descriptor13, this);

    _initializerDefineProperty(this, "_city", _descriptor14, this);

    _initializerDefineProperty(this, "_state", _descriptor15, this);

    _initializerDefineProperty(this, "_firstAndLastName", _descriptor16, this);

    _initializerDefineProperty(this, "_paymentToken", _descriptor17, this);

    _initializerDefineProperty(this, "_fullAVSEnabled", _descriptor18, this);

    _initializerDefineProperty(this, "_fullAVSEnabledMandate", _descriptor19, this);

    _initializerDefineProperty(this, "_isEditingCreditCard", _descriptor20, this);

    _initializerDefineProperty(this, "_savedCardPaymentToken", _descriptor21, this);

    _initializerDefineProperty(this, "_savedCardType", _descriptor22, this);

    _initializerDefineProperty(this, "_cardIndexToLoadDetails", _descriptor23, this);

    _initializerDefineProperty(this, "_creditCardFormFlow", _descriptor24, this);

    _initializerDefineProperty(this, "_errorsYPosition", _descriptor25, this);

    _defineProperty(this, "nameChangeHandlers", []);

    makeObservable(this);
    runInAction(function () {
      _this._fullAVSEnabled = fullAVSEnabled;
      _this._saveCardMandate = saveCardMandate;
      _this._fullAVSEnabledMandate = false;
    });
  }

  _createClass(CreditCardModel, [{
    key: "getValidCountryForZip",
    value: function getValidCountryForZip(zipCode) {
      if (zipCode) {
        var validCountries = COUNTRIES.filter(function (item) {
          return isZipValid(zipCode, item.code);
        });

        if (validCountries.length) {
          return validCountries[0].code;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "registerOnCCNameChangeHandler",
    value: function registerOnCCNameChangeHandler(handler) {
      this.nameChangeHandlers.push(handler);
    }
  }, {
    key: "onUpdateCCName",
    value: function onUpdateCCName() {
      var ccFirstName = this.firstName;
      var ccLastName = this.lastName;
      this.nameChangeHandlers.forEach(function (handler) {
        handler(ccFirstName, ccLastName);
      });
    }
  }, {
    key: "setPaymentTokenToNull",
    value: function setPaymentTokenToNull() {
      this.paymentToken = null;
    }
  }, {
    key: "setIsEditingCreditCard",
    value: function setIsEditingCreditCard() {
      var _this2 = this;

      var _isEditingCreditCard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      runInAction(function () {
        _this2._isEditingCreditCard = _isEditingCreditCard;
      });
    }
  }, {
    key: "setErrorsYPosition",
    value: function setErrorsYPosition(key, _errorsYPosition) {
      var _this3 = this;

      runInAction(function () {
        _this3._errorsYPosition[key] = _errorsYPosition;
      });
    }
  }, {
    key: "resetCreditCardFormFlow",
    value: function resetCreditCardFormFlow() {
      var _this4 = this;

      runInAction(function () {
        _this4._creditCardFormFlow = null;
      });
    }
  }, {
    key: "resetCreditCardModel",
    value: function resetCreditCardModel() {
      var _this5 = this;

      runInAction(function () {
        _this5._expiry = "";
        _this5._firstName = "";
        _this5._lastName = "";
        _this5._cNumber = "";
        _this5._zipCode = "";
        _this5._isDefault = false;
        _this5._addressLine1 = "";
        _this5._addressLine2 = "";
        _this5._country = "US";
        _this5._agreeDisclaimer = false;
        _this5._saveCreditCard = false;
        _this5._cvv = "";
        _this5._city = "";
        _this5._state = "";
        _this5._firstAndLastName = "";
        _this5._paymentToken = null;
        _this5._isEditingCreditCard = false;
        _this5._savedCardPaymentToken = null;
        _this5._savedCardType = null;
        _this5._errorsYPosition = {};
        _this5._cardIndexToLoadDetails = null;
        _this5._creditCardFormFlow = null;
      });
    }
  }, {
    key: "expiry",
    get: function get() {
      return this._expiry;
    },
    set: function set(val) {
      var _this6 = this;

      if (val) {
        var existing = this._expiry;
        var action = existing && val.length < existing.length ? InputAction.DELETE : InputAction.ADD;
        var formattedExpiry = insertDelimiters(val, [2], "/", action);
        var expiryNumber = formattedExpiry ? formattedExpiry.split("/").join("") : "";
        var isNumber = /^\d+$/.test(expiryNumber);

        if (isNumber) {
          runInAction(function () {
            _this6._expiry = formattedExpiry;
          });
        }
      } else {
        runInAction(function () {
          _this6._expiry = val;
        });
      }
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    },
    set: function set(val) {
      var _this7 = this;

      if (val && !isAlphaOrContainsSpace(val)) {
        return;
      }

      runInAction(function () {
        _this7._firstName = val;
      });
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    },
    set: function set(val) {
      var _this8 = this;

      if (val && !isAlphaOrContainsSpace(val)) {
        return;
      }

      runInAction(function () {
        _this8._lastName = val;
      });
    }
  }, {
    key: "cNumber",
    get: function get() {
      return this._cNumber;
    },
    set: function set(val) {
      var _this9 = this;

      if (val) {
        var _valid$number, _valid$number$card;

        var existing = this._cNumber;
        var action = existing && val.length < existing.length ? InputAction.DELETE : InputAction.ADD;
        var gaps = val.length > 3 ? (_valid$number = valid.number(val)) === null || _valid$number === void 0 ? void 0 : (_valid$number$card = _valid$number.card) === null || _valid$number$card === void 0 ? void 0 : _valid$number$card.gaps : null;
        var formattedCCNumber = insertDelimiters(val, gaps, "-", action);
        var cNum = formattedCCNumber ? formattedCCNumber.split("-").join("") : "";
        var isNumber = /^\d+$/.test(cNum);

        if (isNumber) {
          runInAction(function () {
            _this9._cNumber = formattedCCNumber;
          });
        }
      } else {
        runInAction(function () {
          _this9._cNumber = val;
        });
      }
    }
  }, {
    key: "zipCode",
    get: function get() {
      return this._zipCode;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        val = val ? val.split(" ").join("") : val;

        var countryForZip = _this10.getValidCountryForZip(val);

        if (countryForZip) {
          _this10._country = countryForZip;
        }

        _this10._zipCode = val;
      });
    }
  }, {
    key: "isDefault",
    get: function get() {
      return this._isDefault;
    },
    set: function set(val) {
      var _this11 = this;

      runInAction(function () {
        _this11._isDefault = val;
      });
    }
  }, {
    key: "addressLine1",
    get: function get() {
      return this._addressLine1;
    },
    set: function set(val) {
      var _this12 = this;

      runInAction(function () {
        _this12._addressLine1 = val;
      });
    }
  }, {
    key: "addressLine2",
    get: function get() {
      return this._addressLine2;
    },
    set: function set(val) {
      var _this13 = this;

      runInAction(function () {
        _this13._addressLine2 = val;
      });
    }
  }, {
    key: "country",
    get: function get() {
      return this._country;
    },
    set: function set(val) {
      var _this14 = this;

      runInAction(function () {
        _this14._country = val;
      });
    }
  }, {
    key: "agreeDisclaimer",
    get: function get() {
      return this._agreeDisclaimer;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._agreeDisclaimer = val;
      });
    }
  }, {
    key: "saveCreditCard",
    get: function get() {
      return this._saveCreditCard;
    },
    set: function set(val) {
      var _this16 = this;

      runInAction(function () {
        _this16._saveCreditCard = val;
      });
    }
  }, {
    key: "cvv",
    get: function get() {
      return this._cvv;
    },
    set: function set(val) {
      var _this17 = this;

      if (val) {
        var isNumber = val ? /^\d+$/.test(val) : false;

        if (isNumber) {
          runInAction(function () {
            _this17._cvv = val;
          });
        }
      } else {
        runInAction(function () {
          _this17._cvv = val;
        });
      }
    }
  }, {
    key: "city",
    get: function get() {
      return this._city;
    },
    set: function set(val) {
      var _this18 = this;

      runInAction(function () {
        _this18._city = val;
      });
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(val) {
      var _this19 = this;

      runInAction(function () {
        _this19._state = val;
      });
    }
  }, {
    key: "cardInfo",
    get: function get() {
      var _this$numberValidatio;

      return (_this$numberValidatio = this.numberValidationInfo) === null || _this$numberValidatio === void 0 ? void 0 : _this$numberValidatio.card;
    }
  }, {
    key: "saveCardMandateEnabled",
    get: function get() {
      return this._saveCardMandate;
    },
    set: function set(val) {
      var _this20 = this;

      runInAction(function () {
        _this20._saveCardMandate = val;
      });
    }
  }, {
    key: "fullAVSEnabled",
    get: function get() {
      return this._fullAVSEnabled;
    },
    set: function set(val) {
      var _this21 = this;

      runInAction(function () {
        _this21._fullAVSEnabled = val;
      });
    }
  }, {
    key: "firstAndLastName",
    get: function get() {
      return this._firstAndLastName;
    },
    set: function set(val) {
      var _this22 = this;

      if (val && !isAlphaOrContainsSpace(val)) return;
      runInAction(function () {
        var trimmedValue = val === null || val === void 0 ? void 0 : val.trimStart();

        var _extractFromFullName = extractFromFullName(trimmedValue),
            first = _extractFromFullName.first,
            last = _extractFromFullName.last;

        _this22._firstName = first;
        _this22._lastName = !!first ? last : "";
        _this22._firstAndLastName = trimmedValue;
      });
    }
  }, {
    key: "paymentToken",
    get: function get() {
      return this._paymentToken;
    },
    set: function set(paymentToken) {
      var _this23 = this;

      runInAction(function () {
        _this23._paymentToken = paymentToken;
      });
    }
  }, {
    key: "isCCError",
    get: function get() {
      return !this.paymentToken;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var _numberValidationInfo, _numberValidationInfo2, _numberValidationInfo3;

      var numberValidationInfo = this.numberValidationInfo;
      var lengths = numberValidationInfo === null || numberValidationInfo === void 0 ? void 0 : (_numberValidationInfo = numberValidationInfo.card) === null || _numberValidationInfo === void 0 ? void 0 : _numberValidationInfo.lengths;
      var gaps = (numberValidationInfo === null || numberValidationInfo === void 0 ? void 0 : (_numberValidationInfo2 = numberValidationInfo.card) === null || _numberValidationInfo2 === void 0 ? void 0 : (_numberValidationInfo3 = _numberValidationInfo2.gaps) === null || _numberValidationInfo3 === void 0 ? void 0 : _numberValidationInfo3.length) || 0;
      return lengths ? lengths[lengths.length - 1] + gaps : DEFAULT_MAX_CC_NUMBER_LENGTH;
    }
  }, {
    key: "numberValidationInfo",
    get: function get() {
      var _this$cNumber;

      var cNumber = (_this$cNumber = this.cNumber) === null || _this$cNumber === void 0 ? void 0 : _this$cNumber.split("-").join("");
      return cNumber && valid.number(cNumber);
    }
  }, {
    key: "expiryValidationInfo",
    get: function get() {
      return valid.expirationDate(this._expiry);
    }
  }, {
    key: "cvvValidationInfo",
    get: function get() {
      var cardInfo = this.cardInfo;
      return valid.cvv(this._cvv, cardInfo === null || cardInfo === void 0 ? void 0 : cardInfo.code.size);
    }
  }, {
    key: "zipValidationInfo",
    get: function get() {
      return valid.postalCode(this._zipCode, {
        minLength: 5
      });
    }
  }, {
    key: "isFirstNameValid",
    get: function get() {
      return !!this._firstName && isAlphaOrContainsSpace(this._firstName);
    }
  }, {
    key: "isLastNameValid",
    get: function get() {
      return !!this._lastName && isAlphaOrContainsSpace(this._lastName);
    }
  }, {
    key: "isAddressLine1Valid",
    get: function get() {
      var address = this._addressLine1;
      return isAddressValid(address);
    }
  }, {
    key: "isCityValid",
    get: function get() {
      if (this.city) {
        return isCityValid(this.city);
      } else {
        return false;
      }
    }
  }, {
    key: "zipValid",
    get: function get() {
      if (this.zipCode && this.country) {
        return isZipValid(this.zipCode, this.country);
      } else {
        return false;
      }
    }
  }, {
    key: "validCountryForZip",
    get: function get() {
      return this.getValidCountryForZip(this.zipCode);
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.isCreditCardInfoValid;
    }
  }, {
    key: "isCreditCardInfoValid",
    get: function get() {
      var _this$numberValidatio2, _this$numberValidatio3, _this$expiryValidatio, _this$expiryValidatio2, _this$cvvValidationIn, _this$cvvValidationIn2, _this$zipValidationIn, _this$zipValidationIn2;

      var isCardNumberValid = ((_this$numberValidatio2 = this.numberValidationInfo) === null || _this$numberValidatio2 === void 0 ? void 0 : _this$numberValidatio2.isValid) && ((_this$numberValidatio3 = this.numberValidationInfo) === null || _this$numberValidatio3 === void 0 ? void 0 : _this$numberValidatio3.isPotentiallyValid);
      var isExpiryValid = ((_this$expiryValidatio = this.expiryValidationInfo) === null || _this$expiryValidatio === void 0 ? void 0 : _this$expiryValidatio.isValid) && ((_this$expiryValidatio2 = this.expiryValidationInfo) === null || _this$expiryValidatio2 === void 0 ? void 0 : _this$expiryValidatio2.isPotentiallyValid);
      var isCVVValid = ((_this$cvvValidationIn = this.cvvValidationInfo) === null || _this$cvvValidationIn === void 0 ? void 0 : _this$cvvValidationIn.isValid) && ((_this$cvvValidationIn2 = this.cvvValidationInfo) === null || _this$cvvValidationIn2 === void 0 ? void 0 : _this$cvvValidationIn2.isPotentiallyValid);
      var isZipCodeValid = ((_this$zipValidationIn = this.zipValidationInfo) === null || _this$zipValidationIn === void 0 ? void 0 : _this$zipValidationIn.isValid) && ((_this$zipValidationIn2 = this.zipValidationInfo) === null || _this$zipValidationIn2 === void 0 ? void 0 : _this$zipValidationIn2.isPotentiallyValid) && this.zipValid;
      var isCardInfoValid = isCardNumberValid && isExpiryValid && isCVVValid && this.isFirstNameValid && this.isLastNameValid;
      var isAVSInfoValid = this.fullAVSEnabled ? this.isAddressLine1Valid && isZipCodeValid && this.isCityValid && this.state && this.country : isZipCodeValid;
      var isSaveCardInfoValid = !this.saveCardMandateEnabled ? true : this.saveCreditCard ? this.agreeDisclaimer : true;
      return isCardInfoValid && isAVSInfoValid && isSaveCardInfoValid;
    }
  }, {
    key: "billingAddress",
    get: function get() {
      return this.fullAVSEnabled ? {
        lastName: this.lastName,
        country: this.country,
        address2: this.addressLine2,
        city: this.city,
        address1: this.addressLine1,
        postalCode: this.zipCode,
        firstName: this.firstName,
        state: this.state
      } : {
        lastName: this.lastName,
        country: this.country,
        address2: null,
        city: null,
        address1: null,
        postalCode: this.zipCode,
        firstName: this.firstName,
        state: null
      };
    },
    set: function set(_billingAddress) {
      var _this24 = this;

      runInAction(function () {
        _this24._addressLine1 = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.address1;
        _this24._addressLine2 = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.address2;
        _this24._city = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.city;
        _this24._state = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.state;
        _this24._country = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.country;
        _this24._zipCode = _billingAddress === null || _billingAddress === void 0 ? void 0 : _billingAddress.postalCode;
      });
    }
  }, {
    key: "cardBillingAddress",
    get: function get() {
      return this.fullAVSEnabled ? {
        addressLine2: this.addressLine2,
        zip: this.zipCode,
        city: this.city,
        state: this.state,
        country: this.country,
        addressLine1: this.addressLine1,
        isSavedAddress: false
      } : {
        addressLine2: null,
        zip: this.zipCode,
        city: null,
        state: null,
        country: this.country,
        addressLine1: null,
        isSavedAddress: false
      };
    }
  }, {
    key: "card",
    get: function get() {
      return {
        securityCode: this.cvv,
        cardType: "CREDIT",
        cardNumber: this.cNumber.split("-").join(""),
        nameOnCard: [this.firstName, this.lastName].join(" "),
        expYear: this.expiryValidationInfo.year,
        expMonth: this.expiryValidationInfo.month,
        accountType: "CREDIT"
      };
    }
  }, {
    key: "credit",
    get: function get() {
      var _this$numberValidatio4, _this$numberValidatio5;

      var expiryDate = {
        year: this.expiryValidationInfo.year,
        month: this.expiryValidationInfo.month
      };
      var billingAddress = {
        postalCode: this.cardBillingAddress.zip,
        locality: this.cardBillingAddress.city,
        region: this.cardBillingAddress.state,
        country: this.cardBillingAddress.country,
        streetAddress: this.cardBillingAddress.addressLine1
      };
      return {
        securityCode: this.cvv,
        cardType: (_this$numberValidatio4 = this.numberValidationInfo) === null || _this$numberValidatio4 === void 0 ? void 0 : (_this$numberValidatio5 = _this$numberValidatio4.card) === null || _this$numberValidatio5 === void 0 ? void 0 : _this$numberValidatio5.type.toUpperCase(),
        cardNumber: this.cNumber.split("-").join(""),
        nameOnCard: [this.firstName, this.lastName].join(" "),
        expiryDate: expiryDate,
        billingAddress: billingAddress
      };
    }
  }, {
    key: "cardAccount",
    get: function get() {
      if (this.isCreditCardInfoValid) {
        return {
          card: this.card,
          billingAddress: this.cardBillingAddress
        };
      } else {
        return null;
      }
    }
  }, {
    key: "cardAccountRSA",
    get: function get() {
      if (this.isCreditCardInfoValid) {
        return {
          type: "CREDIT",
          credit: this.credit
        };
      } else {
        return null;
      }
    }
  }, {
    key: "creditCardPaymentInfo",
    get: function get() {
      if (this.isCreditCardInfoValid) {
        return {
          card: this.card,
          billingAddress: this.billingAddress
        };
      } else {
        return null;
      }
    }
  }, {
    key: "fullAVSEnabledMandate",
    get: function get() {
      return this._fullAVSEnabledMandate;
    },
    set: function set(val) {
      var _this25 = this;

      runInAction(function () {
        _this25._fullAVSEnabledMandate = val;
      });
    }
  }, {
    key: "checkIfZipValid",
    get: function get() {
      var zipValidationInfo = this.zipValidationInfo;
      return zipValidationInfo.isValid && zipValidationInfo.isPotentiallyValid && this.zipValid;
    }
  }, {
    key: "isEditingCreditCard",
    get: function get() {
      return this._isEditingCreditCard;
    }
  }, {
    key: "savedCardPaymentToken",
    get: function get() {
      return this._savedCardPaymentToken;
    },
    set: function set(_savedCardPaymentToken) {
      var _this26 = this;

      runInAction(function () {
        _this26._savedCardPaymentToken = _savedCardPaymentToken;
      });
    }
  }, {
    key: "savedCardType",
    get: function get() {
      return this._savedCardType;
    },
    set: function set(_savedCardType) {
      var _this27 = this;

      runInAction(function () {
        _this27._savedCardType = _savedCardType;
      });
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "isCardNumberValid",
    get: function get() {
      var _this$numberValidatio6, _this$numberValidatio7;

      return ((_this$numberValidatio6 = this.numberValidationInfo) === null || _this$numberValidatio6 === void 0 ? void 0 : _this$numberValidatio6.isValid) && ((_this$numberValidatio7 = this.numberValidationInfo) === null || _this$numberValidatio7 === void 0 ? void 0 : _this$numberValidatio7.isPotentiallyValid);
    }
  }, {
    key: "isCardExpiryValid",
    get: function get() {
      var _this$expiryValidatio3, _this$expiryValidatio4;

      return ((_this$expiryValidatio3 = this.expiryValidationInfo) === null || _this$expiryValidatio3 === void 0 ? void 0 : _this$expiryValidatio3.isValid) && ((_this$expiryValidatio4 = this.expiryValidationInfo) === null || _this$expiryValidatio4 === void 0 ? void 0 : _this$expiryValidatio4.isPotentiallyValid);
    }
  }, {
    key: "isCardCVVValid",
    get: function get() {
      if (!!this._cvv) {
        if (this.isEditingCreditCard) {
          return this._cvv.length === this.cardCVVLength;
        } else {
          return this.cvvValidationInfo.isValid && this.cvvValidationInfo.isPotentiallyValid;
        }
      }

      return false;
    }
  }, {
    key: "isZipCodeValid",
    get: function get() {
      var _this$zipValidationIn3, _this$zipValidationIn4;

      return ((_this$zipValidationIn3 = this.zipValidationInfo) === null || _this$zipValidationIn3 === void 0 ? void 0 : _this$zipValidationIn3.isValid) && ((_this$zipValidationIn4 = this.zipValidationInfo) === null || _this$zipValidationIn4 === void 0 ? void 0 : _this$zipValidationIn4.isPotentiallyValid) && this.zipValid;
    }
  }, {
    key: "cardCVVLabel",
    get: function get() {
      var _getCardTypeInfo, _getCardTypeInfo$code, _this$numberValidatio8, _this$numberValidatio9, _this$numberValidatio10;

      return this.isEditingCreditCard ? (_getCardTypeInfo = getCardTypeInfo(this.savedCardType)) === null || _getCardTypeInfo === void 0 ? void 0 : (_getCardTypeInfo$code = _getCardTypeInfo.code) === null || _getCardTypeInfo$code === void 0 ? void 0 : _getCardTypeInfo$code.name : ((_this$numberValidatio8 = this.numberValidationInfo) === null || _this$numberValidatio8 === void 0 ? void 0 : (_this$numberValidatio9 = _this$numberValidatio8.card) === null || _this$numberValidatio9 === void 0 ? void 0 : (_this$numberValidatio10 = _this$numberValidatio9.code) === null || _this$numberValidatio10 === void 0 ? void 0 : _this$numberValidatio10.name) || "CVV*";
    }
  }, {
    key: "cardCVVLength",
    get: function get() {
      var _getCardTypeInfo2, _getCardTypeInfo2$cod, _this$numberValidatio11, _this$numberValidatio12, _this$numberValidatio13;

      return this.isEditingCreditCard ? (_getCardTypeInfo2 = getCardTypeInfo(this.savedCardType)) === null || _getCardTypeInfo2 === void 0 ? void 0 : (_getCardTypeInfo2$cod = _getCardTypeInfo2.code) === null || _getCardTypeInfo2$cod === void 0 ? void 0 : _getCardTypeInfo2$cod.size : ((_this$numberValidatio11 = this.numberValidationInfo) === null || _this$numberValidatio11 === void 0 ? void 0 : (_this$numberValidatio12 = _this$numberValidatio11.card) === null || _this$numberValidatio12 === void 0 ? void 0 : (_this$numberValidatio13 = _this$numberValidatio12.code) === null || _this$numberValidatio13 === void 0 ? void 0 : _this$numberValidatio13.size) || 3;
    }
  }, {
    key: "cardType",
    get: function get() {
      var _this$numberValidatio14, _this$numberValidatio15;

      return this.isEditingCreditCard ? this.savedCardType : (_this$numberValidatio14 = this.numberValidationInfo) === null || _this$numberValidatio14 === void 0 ? void 0 : (_this$numberValidatio15 = _this$numberValidatio14.card) === null || _this$numberValidatio15 === void 0 ? void 0 : _this$numberValidatio15.type;
    }
  }, {
    key: "isCreditCardFormDetailsEmpty",
    get: function get() {
      var isDataPresentInForm = !!this._firstName || !!this._lastName || !!this._cNumber || !!this._expiry || !!this._cvv || !!this._addressLine1 || !!this._addressLine2 || !!this._zipCode || !!this._city || !!this._state;
      return !isDataPresentInForm;
    }
  }, {
    key: "cardIndexToLoadDetails",
    get: function get() {
      return this._cardIndexToLoadDetails;
    },
    set: function set(_cardIndexToLoadDetails) {
      var _this28 = this;

      runInAction(function () {
        _this28._cardIndexToLoadDetails = _cardIndexToLoadDetails;
      });
    }
  }, {
    key: "creditCardFormFlow",
    get: function get() {
      return this._creditCardFormFlow;
    },
    set: function set(_creditCardFormFlow) {
      var _this29 = this;

      runInAction(function () {
        _this29._creditCardFormFlow = _creditCardFormFlow;
      });
    }
  }]);

  return CreditCardModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_expiry", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_firstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_cNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_zipCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isDefault", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_addressLine1", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_addressLine2", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_country", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "US";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_agreeDisclaimer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_saveCreditCard", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_cvv", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_saveCardMandate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_city", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_state", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_firstAndLastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_paymentToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_fullAVSEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_fullAVSEnabledMandate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_isEditingCreditCard", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_savedCardPaymentToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_savedCardType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_cardIndexToLoadDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_creditCardFormFlow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expiry", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expiry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDefault", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressLine1", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addressLine1"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressLine2", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "addressLine2"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "country", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "country"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "agreeDisclaimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "agreeDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveCreditCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saveCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cvv", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cvv"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "city", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "city"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "state", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "state"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveCardMandateEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "saveCardMandateEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullAVSEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fullAVSEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstAndLastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstAndLastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCCError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCCError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberValidationInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberValidationInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expiryValidationInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expiryValidationInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cvvValidationInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cvvValidationInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipValidationInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipValidationInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstNameValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstNameValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLastNameValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLastNameValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAddressLine1Valid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAddressLine1Valid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCityValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCityValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validCountryForZip", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validCountryForZip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCreditCardInfoValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCreditCardInfoValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "billingAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "billingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardBillingAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardBillingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "card", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "card"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "credit", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "credit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardAccount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardAccountRSA", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardAccountRSA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "creditCardPaymentInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "creditCardPaymentInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullAVSEnabledMandate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fullAVSEnabledMandate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkIfZipValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkIfZipValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEditingCreditCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEditingCreditCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCardPaymentToken", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedCardPaymentToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCardType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "savedCardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCardNumberValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCardNumberValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCardExpiryValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCardExpiryValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCardCVVValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCardCVVValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isZipCodeValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isZipCodeValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardCVVLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardCVVLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardCVVLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardCVVLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCreditCardFormDetailsEmpty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCreditCardFormDetailsEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardIndexToLoadDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardIndexToLoadDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "creditCardFormFlow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "creditCardFormFlow"), _class.prototype)), _class);
export { CreditCardModel as default };